<top-action-bar></top-action-bar>
<main-panel *ngIf="isLogedIn"></main-panel>

<ng-chat [adapter]="chatAdapter" [groupAdapter]="chatAdapter" [fileUploadAdapter]="chatAdapter"
(onParticipantClicked)="chatAdapter.onParticipantClicked($event)"
(onParticipantChatClosed)="chatAdapter.onParticipantChatClosed($event)"
[title]="'An Việt Phát'" [theme]="'dark-theme'" [userId]="userId"></ng-chat>
